import * as yup from 'yup';

export const schemaPermissionsCreate = yup.object().shape({
  access_group_id: yup.string().required('Id do grupo de acesso obrigatório'),
  value: yup.string().required('Permissoes obrigatória'),
});

export const schemaPermissionsEdit = yup.object().shape({
  value: yup.string().required('Permissoes obrigatória'),
});
